import {
  ACCESS_FILTER_ALL,
  ACCESS_FILTER_PRIVATE,
  ACCESS_FILTER_PUBLIC,
  ACCESS_FILTER_QUERY_PARAM,
} from './publicMoorageConstants';

export const PUBLIC_MOORAGES_QUERY_PARAM = 'publicMoorages';
export const ACCESS_QUERY_PARAM = ACCESS_FILTER_QUERY_PARAM;

export const normalizeAccessFilter = value => {
  if (value === ACCESS_FILTER_PUBLIC) {
    return ACCESS_FILTER_PUBLIC;
  }
  if (value === ACCESS_FILTER_PRIVATE) {
    return ACCESS_FILTER_PRIVATE;
  }
  return ACCESS_FILTER_ALL;
};

export const isAccessFilterActive = value => normalizeAccessFilter(value) !== ACCESS_FILTER_ALL;

// Backward-compatible helper for old "show public moorages" callers/tests.
export const isPublicMooragesFilterEnabled = value => value === true || value === 'true';
